import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faUsers, faChevronRight, faCircleInfo, faTrash, faUserPlus } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'

import { lP, boxvar2_1, boxvar4, URL_MAINAPI, API_TOKEN, validateOrganizationUpdate, validateObjectId } from '../../../main.js'

import '../../../main.css'
import './ManageOrganizationEdit.css'
import './MManageOrganizationEdit.css'

import Cookies from 'universal-cookie'

export default function ManageOrganizationEdit() {

    var [loadedOrgData, setLoadedOrgData] = useState(0)
    var [banner, setBanner] = useState(null)
    var [managerBanner, setManagerBanner] = useState(null)
    var [managers, setManagers] = useState([])
    var [newManagerId, setNewManagerId] = useState("")

    const cookies = new Cookies()
    let cur_authtoken = cookies.get('authtoken')
    let cur_userid = cookies.get('userid')

    const { orgid } = useParams()

    var [formData, setFormData] = useState({
        formName: "",
        formDescription: "",
        formMail: "",
        formTel: "",
        formUrl: "",
        formImprintUrl: "",
    })

    useEffect(() => {
        getOrgData()
    }, [orgid])

    function applyOrgData(org) {
        setFormData({
            formName: org.name || "",
            formDescription: org.description || "",
            formMail: (org.contact && org.contact.email) || "",
            formTel: (org.contact && org.contact.tel) || "",
            formUrl: (org.contact && org.contact.url) || "",
            formImprintUrl: (org.contact && org.contact.imprint_url) || "",
        })
        setManagers(Array.isArray(org.managers) ? org.managers : [])
    }

    function getOrgData() {
        setLoadedOrgData(0)
        try {
            fetch(URL_MAINAPI + "/organization/usermanages/" + orgid, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    applyOrgData(res.data)
                    setLoadedOrgData(1)
                } else {
                    setLoadedOrgData(-1)
                }
            }))
        } catch (err) {
            setLoadedOrgData(-1)
        }
    }

    function setField(key, value) {
        setFormData({ ...formData, [key]: value })
    }

    function doSave() {
        setBanner(null)

        var check = validateOrganizationUpdate({
            name: formData.formName,
            description: formData.formDescription,
            email: formData.formMail,
            tel: formData.formTel,
            url: formData.formUrl,
            imprint_url: formData.formImprintUrl,
        })
        if (check.error != null) {
            setBanner({ type: "error", text: "Bitte überprüfe deine Eingaben. Alle Pflichtfelder müssen korrekt ausgefüllt sein." })
            return
        }

        setBanner({ type: "loading", text: "Änderungen werden gespeichert..." })

        var reqbody = {
            "name": formData.formName,
            "description": formData.formDescription,
            "contact": {
                "email": formData.formMail,
                "tel": formData.formTel,
                "url": formData.formUrl,
                "imprint_url": formData.formImprintUrl,
            }
        }

        try {
            fetch(URL_MAINAPI + "/organization/" + orgid, {
                method: "PATCH",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                body: JSON.stringify(reqbody),
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    applyOrgData(res.data)
                    setBanner({ type: "done", text: "Die Organisationsdaten wurden erfolgreich gespeichert." })
                } else {
                    setBanner({ type: "error", text: "Fehler beim Speichern: " + (res.data.error || "unbekannter Fehler") })
                }
            }))
        } catch (err) {
            setBanner({ type: "error", text: "Es gab einen Fehler bei der Verarbeitung: " + err })
        }
    }

    function doAddManager() {
        setManagerBanner(null)
        var idCheck = validateObjectId(newManagerId)
        if (idCheck.error != null) {
            setManagerBanner({ type: "error", text: "Bitte gib eine gültige User-ID ein (24 Zeichen)." })
            return
        }

        setManagerBanner({ type: "loading", text: "Manager wird hinzugefügt..." })

        try {
            fetch(URL_MAINAPI + "/organization/" + orgid + "/managers", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                body: JSON.stringify({ userid: newManagerId.trim() }),
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    applyOrgData(res.data)
                    setNewManagerId("")
                    setManagerBanner({ type: "done", text: "Manager wurde hinzugefügt." })
                } else {
                    setManagerBanner({ type: "error", text: "Fehler: " + (res.data.error || "unbekannter Fehler") })
                }
            }))
        } catch (err) {
            setManagerBanner({ type: "error", text: "Es gab einen Fehler bei der Verarbeitung: " + err })
        }
    }

    function doRemoveManager(userid) {
        setManagerBanner(null)
        if (!window.confirm("Diesen Manager wirklich entfernen?")) return

        setManagerBanner({ type: "loading", text: "Manager wird entfernt..." })

        try {
            fetch(URL_MAINAPI + "/organization/" + orgid + "/managers/" + userid, {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    applyOrgData(res.data)
                    setManagerBanner({ type: "done", text: "Manager wurde entfernt." })
                } else {
                    setManagerBanner({ type: "error", text: "Fehler: " + (res.data.error || "unbekannter Fehler") })
                }
            }))
        } catch (err) {
            setManagerBanner({ type: "error", text: "Es gab einen Fehler bei der Verarbeitung: " + err })
        }
    }

    function managerId(m) {
        if (!m) return ""
        if (typeof m === 'string') return m
        return String(m._id)
    }

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Organisation bearbeiten</title>
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body container section' style={{ paddingTop: '36px' }}>
                <div className='breadcrumb'>
                    <a href='/profil'>Profil</a>
                    <FontAwesomeIcon icon={faChevronRight} />
                    <a href={'/manage/org/' + orgid}>{formData.formName || 'Organisation'}</a>
                    <FontAwesomeIcon icon={faChevronRight} />
                    <span>Bearbeiten</span>
                </div>

                <motion.h1
                    variants={boxvar4}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className='section-title'
                    style={{ marginBottom: '6px' }}
                >
                    Organisation bearbeiten
                </motion.h1>
                <p className='section-sub'>Verwalte Stammdaten und Manager dieser Organisation.</p>

                {(loadedOrgData == 0) ? (
                    <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} style={{ marginTop: '20px', maxWidth: '720px' }}>
                        <div className='card' style={{ padding: '26px 24px' }}>
                            <Skeleton width="40%" height={20} />
                            <Skeleton width="100%" height={16} />
                            <Skeleton width="100%" height={16} />
                            <Skeleton width="60%" height={16} />
                            <Skeleton width="35%" height={38} />
                        </div>
                    </motion.div>
                ) : (loadedOrgData == -1) ? (
                    <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} style={{ marginTop: '20px' }}>
                        <div className='card orgedit-error-card'>
                            <h3>Die Organisation konnte nicht geladen werden.</h3>
                            <p>Du bist möglicherweise kein Manager dieser Organisation, oder sie ist nicht aktiv.</p>
                            <CTAButton variant="primary" hideArrow={false} title={"Zum Profil"} onclick={() => lP('/profil')} />
                        </div>
                    </motion.div>
                ) : (
                    <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} style={{ marginTop: '20px' }}>
                        <div className='card orgedit-card'>
                            <div className='orgedit-headline'>
                                <span className='orgedit-icon'><FontAwesomeIcon icon={faBuilding} /></span>
                                <h3>Stammdaten</h3>
                            </div>

                            <form>
                                <div className='orgedit-grid'>
                                    <div className="field orgedit-full">
                                        <label htmlFor="oe-name">Name</label>
                                        <input id="oe-name" type="text" maxLength="80" minLength="2" name="name" placeholder="Organisationsname" value={formData.formName} onInput={(e) => setField('formName', e.target.value)}></input>
                                    </div>
                                    <div className="field orgedit-full">
                                        <label htmlFor="oe-desc">Beschreibung</label>
                                        <textarea id="oe-desc" name="description" rows="3" maxLength="1000" placeholder="Kurzbeschreibung (optional)" value={formData.formDescription} onInput={(e) => setField('formDescription', e.target.value)}></textarea>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="oe-mail">E-Mail</label>
                                        <input id="oe-mail" type="email" name="email" placeholder="kontakt@organisation.de" value={formData.formMail} autoComplete='email' onInput={(e) => setField('formMail', e.target.value)}></input>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="oe-tel">Telefon</label>
                                        <input id="oe-tel" type="tel" name="tel" placeholder="Telefonnummer" value={formData.formTel} autoComplete='tel' onInput={(e) => setField('formTel', e.target.value)}></input>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="oe-url">Website</label>
                                        <input id="oe-url" type="url" name="url" placeholder="https://… (optional)" value={formData.formUrl} onInput={(e) => setField('formUrl', e.target.value)}></input>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="oe-imprint">Impressum-URL</label>
                                        <input id="oe-imprint" type="url" name="imprint" placeholder="https://…/impressum" value={formData.formImprintUrl} onInput={(e) => setField('formImprintUrl', e.target.value)}></input>
                                    </div>
                                </div>

                                {banner ? (
                                    <div className={'orgedit-banner orgedit-banner-' + banner.type} role={banner.type === 'error' ? 'alert' : 'status'}>
                                        <FontAwesomeIcon icon={faCircleInfo} /> {banner.text}
                                    </div>
                                ) : null}

                                <div className='orgedit-actions'>
                                    <CTAButton variant="primary" hideArrow={false} title={"Speichern"} onclick={() => doSave()} />
                                    <CTAButton variant="secondary" hideArrow={true} title={"Abbrechen"} onclick={() => lP('/manage/org/' + orgid)} />
                                </div>
                            </form>

                            <div className='orgedit-managers-block'>
                                <div className='orgedit-headline'>
                                    <span className='orgedit-icon'><FontAwesomeIcon icon={faUsers} /></span>
                                    <h3>Manager</h3>
                                </div>
                                <p className='orgedit-managers-hint'>
                                    Manager können Events und diese Organisation verwalten. Zum Hinzufügen brauchst du die User-ID der Person – sie steht etwas versteckt unten im Profil unter „Profil bearbeiten“. Gib deine User-ID nur an berechtigte Personen weiter.{' '}
                                    <a href="/faq#911-organisation--manager-bearbeiten">Mehr dazu in der FAQ</a>.
                                </p>

                                <ul className='orgedit-manager-list'>
                                    {managers.map(function (m) {
                                        const mid = managerId(m)
                                        const isSelf = String(mid) === String(cur_userid)
                                        const canRemove = !isSelf && managers.length > 1
                                        const firstname = (m && typeof m === 'object' && m.firstname) ? m.firstname : ''
                                        const lastname = (m && typeof m === 'object' && m.lastname) ? m.lastname : ''
                                        const email = (m && typeof m === 'object' && m.contact && m.contact.email) ? m.contact.email : ''
                                        const displayName = (firstname || lastname)
                                            ? (firstname + ' ' + lastname).trim()
                                            : (mid ? ('User ' + mid.slice(-6)) : 'Unbekannt')
                                        return (
                                            <li key={mid || displayName} className='orgedit-manager-row'>
                                                <div className='orgedit-manager-info'>
                                                    <strong>
                                                        {displayName}
                                                        {isSelf ? ' (du)' : ''}
                                                    </strong>
                                                    {email ? <span className='orgedit-manager-meta'>{email}</span> : null}
                                                </div>
                                                <div className='orgedit-manager-actions'>
                                                    {canRemove ? (
                                                        <button type="button" className='btn btn-quiet btn-sm' style={{ color: 'var(--error)' }} onClick={() => doRemoveManager(mid)}>
                                                            <FontAwesomeIcon icon={faTrash} /> Entfernen
                                                        </button>
                                                    ) : (
                                                        <span className='orgedit-manager-locked' title={isSelf ? 'Du kannst dich nicht selbst entfernen' : 'Mindestens ein Manager muss bleiben'}>
                                                            {isSelf ? 'nicht entfernbar' : 'letzter Manager'}
                                                        </span>
                                                    )}
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>

                                <div className='orgedit-add-manager'>
                                    <div className="field">
                                        <label htmlFor="oe-newmanager"><FontAwesomeIcon icon={faUserPlus} /> Manager hinzufügen (User-ID)</label>
                                        <input id="oe-newmanager" type="text" name="newmanager" placeholder="z. B. 507f1f77bcf86cd799439011" value={newManagerId} onInput={(e) => setNewManagerId(e.target.value.trim())} autoComplete='off' spellCheck={false}></input>
                                    </div>
                                    <CTAButton variant="secondary" hideArrow={true} title={"Hinzufügen"} onclick={() => doAddManager()} />
                                </div>

                                {managerBanner ? (
                                    <div className={'orgedit-banner orgedit-banner-' + managerBanner.type} role={managerBanner.type === 'error' ? 'alert' : 'status'}>
                                        <FontAwesomeIcon icon={faCircleInfo} /> {managerBanner.text}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </motion.div>
                )}
            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
